/* globals rxSwitchboard */
var Rx = require('ub_wrapped/rx');
var jQuery = require('jquery');
var _ = require('lodash');
var ubBanzai = require('ub/control/banzai-features');

;(function(){

  // "exports" at bottom
  var ParallaxFixer = {
    runFix: function(){
      var rxUi   = window.rxUi;
      var lp     = window.lp;
      var editor = window.editor;

      var $canvas = jQuery('#canvas-body');

      this.elements = editor.page.getParalaxEnabledElements();

      this.isChrome = _.isObject(window.chrome) && _.isObject(window.chrome.webstore);
      this.isChromeRetina = window.devicePixelRatio >= 2 && this.isChrome;

      this.updateParallaxBgProperties($canvas); // on load

      //TODO: remove this direct use of rxUi.eventBus
      Rx.Observable
        .merge(lp.pom.NewBGPropsHelper.changeEvents,
            rxSwitchboard.subjects.page_updated_and_refreshed,
            rxUi.eventBus.eventSinks.Editor.ub_multiFilterOn(
              'type',
              ['toggleTree', 'updateForWindowResize']),
            rxUi.eventBus.eventSinks.TriPane)
        .ub_subscribe(_.partial(this.updateParallaxBgProperties, $canvas));

      if (ubBanzai.features.isDebugModeEnabled()) {
        console.info('ParallaxFixer:', 'Enabling');
      }

      if (this.isChromeRetina) {
        // This is done to fix image shearing in Chrome on retina
        // This may not be needed in future chrome updates
        this.addChromeScrollFix();
      }
    },

    addChromeScrollFix: function() {
      if (ubBanzai.features.isDebugModeEnabled()) {
        console.info('ParallaxFixer:', 'Enabling chrome retina fix');
      }

      return Rx.Observable
        .fromEvent(jQuery('#canvas-body'), 'scroll')
        .sample(10)
        .subscribe(this.adjustBgForScrolling.bind(this));
    },

    adjustBgForScrolling: function(/* ev */) {
      _.forEach(this.elements, function(el) {
        var $el          = jQuery(el.view.e);
        var currentBgPos = $el.css('backgroundPosition').split(' ');
        var xPos         = currentBgPos[0];

        var yPos = _.parseInt(
            currentBgPos[1]
            .substring(0, currentBgPos[1].length - 2)
            ) + 0.01;

        var newPos = [ xPos, yPos + 'px' ];

        $el.css("backgroundPosition", newPos.join(' '));
        $el.css('backgroundPosition'); // must read from the dom to force the repaint here
        $el.css("backgroundPosition", currentBgPos.join(' '));
      });

    },

    // Mutates the DOM
    // NOTE: Since a form confirmation does not have a proper root that we
    // can apply parallax on we don't add it there.
    updateParallaxBgProperties: function($canvasElement) {

      // Prevent the fixer from running on the mobile breakpoint
      if (window.editor.page.isMobileBreakpoint()) { return; }

      if (ubBanzai.features.isDebugModeEnabled()) {
        console.debug('ParallaxFixer: Updating offsets and sizes');
      }
      var lp     = window.lp;
      var editor = window.editor;

      var canvas = _canvasProperties($canvasElement);
      _.chain(editor.page.elements).filter(function(el){
        return _.contains(['lp-pom-root', 'lp-pom-block', 'lp-pom-box'], el.type) &&
          Boolean(el.model.safeGet('geometry.visible')) &&
          ! (el.type === 'lp-pom-root' && editor.page.isFormConfirmation());
      })
      .map(function(el){
        return {
          id    : el.id,
          props : lp.pom.NewBGPropsHelper.getProperties(el.model)
        };
      })
      .filter(function(el){
        return el.props.image && el.props.parallax;
      })
      .forEach(function(el) {
        el.props.id = el.id;
        jQuery('#'+el.id).css(this.generateCss(canvas, el.props));
      }, this);
    },

    generateCss: function(canvas, props){
      var newCss = {
        backgroundAttachment : 'fixed',
        backgroundPosition   : [
          _calculateXPosition(props, props.image, canvas),
          _calculateYPosition(props, props.image, canvas)
        ].join(' ')
      };

      if (props.fitToContainer) {
        newCss.backgroundSize = _newBgSize(props.image.size, canvas).join(' ');
      }
      return newCss;
    }
  };

  var _canvasProperties = function($el) {
    var offset = $el.offset();
    var el = $el.get(0); // de-jquery
    return {
      top    : offset.top,
      left   : offset.left,
      width  : el.clientWidth,
      height : el.clientHeight
    };
  };

  var _averageCenter = function(canvasOffset, canvasSize, originalImageSize) {
    return (canvasSize / 2) - (originalImageSize / 2) + ( canvasOffset );
  };

  var _aspect = function(image){
    return {
      isTallOrSquare: _isSquareAspectRatio(image) || // we must handle all cases, most
        _isTallAspectRatio(image),                   // displays are wider than taller
      isWide: _isWideAspectRatio(image)
    };
  };

  var _bgPos = function(props){
    var pos = props.position.split(' ');
    return {
      x : pos[0],
      y : pos[1]
    };
  };

  var _calcOutsideAlignment = function(fitToContainer, isMatchedAspectRatio, canvasOffset, canvasSize, imageSize, newImageSize) {
    if (fitToContainer) {
      return isMatchedAspectRatio ? (canvasOffset + canvasSize - newImageSize) : canvasOffset;
    } else {
      return canvasOffset + canvasSize - imageSize;
    }
  };

  var _isImgTallerThanCanvas = function(imageHeight, canvasHeight) {
    return imageHeight > canvasHeight;
  };

  var _calculateXPosition = function(props, image, canvas) {
    var newImgWidth        = _calculateNewImageWidth(image, canvas)
      , fit                = props.fitToContainer
      , canvasAspectRatio  = _aspectRatio(canvas)
      , imageAspectRatio   = _aspectRatio(image)
      , isWide             = _aspect(image).isWide;

    var pos;
    if (props.fitToContainer){
      if (isWide && imageAspectRatio > canvasAspectRatio) {
        var posX;
        switch(_bgPos(props).x) {
          case 'left':
            posX = 0;
            break;

          case 'center':
            posX = 0.5;
            break;

          case 'right':
            posX = 1;
            break;
        }
        pos = ( canvas.width - canvas.height * imageAspectRatio ) * posX + canvas.left;

      } else {
        pos = canvas.left;
      }
    } else {
      switch(_bgPos(props).x) {

        case 'left':
          pos = canvas.left;
          break;

        case 'center':
          pos = canvas.left + Math.round((canvas.width - image.width) / 2 );
          break;

        case 'right':
          pos = _calcOutsideAlignment(fit, isWide, canvas.left, canvas.width, image.width, newImgWidth);
          break;

        default: // none
      }
    }
    return pos + 'px';
  };

  var _calculateYPosition  = function(props, image, canvas) {
    var newImgHeight       = _calculateNewImageHeight(image, canvas)
      , fit                = props.fitToContainer
      , isTallOrSquare     = _aspect(image).isTallOrSquare
      , isWide             = _aspect(image).isWide
      , canvasAspectRatio  = _aspectRatio(canvas)
      , imageAspectRatio   = _aspectRatio(image)
      , isTallerThanCanvas = _isImgTallerThanCanvas(image.height, canvas.height);

    var pos;
    if ( fit && isWide && imageAspectRatio > canvasAspectRatio) {
      pos = canvas.top;
    } else {
      switch(_bgPos(props).y) {

        case 'top':
          pos = canvas.top;
          break;

        case 'center':
          var shelfHeight = 36;
          if (fit) {
            pos = _averageCenter(canvas.top, canvas.height, newImgHeight);
          } else {
            pos = canvas.top + shelfHeight + Math.round((canvas.height - image.height) / 2 );
          }
          break;

        case 'bottom':
          pos = _calcOutsideAlignment(fit, isTallOrSquare || isTallerThanCanvas, canvas.top, canvas.height, image.height, newImgHeight);
          break;

        default: //none

      }
    }
    return pos + 'px';
  };

  var _newBgSize = function(image, canvas) {
    var width  = 'auto'
      , height = 'auto';

    if ( _isWideAspectRatio(image) && _aspectRatio(image) > _aspectRatio(canvas)) {
      height = canvas.height + 'px';
    } else {
      width = canvas.width + 'px';
    }

    return [width, height];
  };

  var _aspectRatio = function(image) {
    return image.width/image.height;
  };

  var _isSquareAspectRatio = function(image) {
    return image.width === image.height;
  };

  var _isWideAspectRatio = function(image) {
    return _aspectRatio(image) > 1;
  };

  var _isTallAspectRatio = function(image) {
    return _aspectRatio(image) < 1;
  };

  var _calculateNewImageWidth = function(image, canvas) {
    return image.width * ( canvas.height / image.height );
  };

  var _calculateNewImageHeight = function(image, canvas) {
    var widthRatio = canvas.width / image.width;
    return image.height * widthRatio;
  };

  var _protectedMethods = {
    newBgSize     : _newBgSize,
    yPos          : _calculateYPosition,
    averageCenter : _averageCenter,
    xPos          : _calculateXPosition
  };

  window.lp.editor = window.lp.editor || {};
  window.lp.editor.ParallaxFixer = _.merge(ParallaxFixer, _protectedMethods);
  _.bindAll(window.lp.editor.ParallaxFixer);

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/parallax_fixer.js
// module id = 998
// module chunks = 0